import { type ReactElement } from "react";
import { type Thread } from "../../types";
import { ChatThreadUnavailableSurface } from "./ChatThreadUnavailableSurface";
import { type ServerThreadStatus } from "./serverThreadStatus";

export function renderChatThreadBootstrapSurface(input: {
  readonly activeThread: Thread | undefined;
  readonly projectTitle: string | null;
  readonly routeKind: "server" | "draft";
  readonly serverThreadStatus: ServerThreadStatus;
  readonly serverThreadSubscriptionError: string | null;
}): ReactElement | null {
  if (!input.activeThread || input.serverThreadStatus === "missing") {
    return (
      <ChatThreadUnavailableSurface
        routeKind={input.routeKind}
        serverThreadStatus={input.serverThreadStatus}
        serverThreadSubscriptionError={input.serverThreadSubscriptionError}
      />
    );
  }

  // A known thread already has its shell, breadcrumb identity, composer, and
  // surrounding thread chrome. Keep that complete surface mounted while the
  // detail subscription catches up so connecting never replaces the thread
  // with a full-panel skeleton. The timeline will fill in from the same store
  // as soon as the detail snapshot arrives.
  return null;
}
